import "../QuoteForm.css";


function QuoteTotalsSection({ subtotal, discount = 0, tax, grandTotal }) {
    const formatCurrency = (num) => {
        return num.toLocaleString("ko-KR") + "원";
    };

    return (
        <div className="quote-totals-v2">
            <div className="total-row-v2">
                <label>소계:</label>
                <span>{formatCurrency(subtotal)}</span>
            </div>
            {discount > 0 && (
                <div className="total-row-v2">
                    <label>패키지 할인 (-10%):</label>
                    <span>-{formatCurrency(discount)}</span>
                </div>
            )}
            <div className="total-row-v2">
                <label>부가세 (10%):</label>
                <span>{formatCurrency(tax)}</span>
            </div>
            <div className="total-row-v2 grand-total-v2">
                <label>총 견적금액:</label>
                <span>{formatCurrency(grandTotal)}</span>
            </div>
        </div>
    );
}

export default QuoteTotalsSection;